export default __webpack_public_path__ + "static/media/caliper-laptop-licensed.f5a8ebbe.png";